import { Namespace, useTypedT } from "@racoon/i18n";

export const SoonBadge = () => {
  const t = useTypedT(Namespace.Govdash);

  return (
    <span className="shrink-0 whitespace-nowrap rounded-full bg-slate-200 px-2 py-0.5 text-xs font-semibold uppercase text-text-secondary">
      {t("monitor.soon")}
    </span>
  );
};
